import { Link } from "react-router-dom";
import { OnAirSign } from "../components/OnAirSign";

export default function Landing() {
  return (
    <div className="min-h-screen spotlight grain flex flex-col" data-testid="landing-page">
      <header className="flex items-center justify-between px-6 md:px-12 h-16">
        <span className="flex items-center gap-2">
          <span className="grid h-7 w-7 place-items-center rounded-[3px] bg-yellow-400 text-black font-black">B</span>
          <span className="font-black tracking-tight text-lg">BANDCAMP</span>
        </span>
        <Link to="/sign-in" className="text-sm text-zinc-300 hover:text-yellow-300" data-testid="landing-sign-in-link">Sign in</Link>
      </header>
      <section className="flex-1 flex flex-col justify-center px-6 md:px-12 max-w-4xl rise">
        <OnAirSign on />
        <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
          The music camp<br />with <span className="text-yellow-400">eight stages</span>.
        </h1>
        <p className="mt-5 max-w-xl text-base text-zinc-400">
          Learn, rehearse and perform live. Every room has a stage, a 12-channel mixer, chat and shared tracks.
        </p>
        <div className="mt-8 flex gap-3">
          <Link to="/sign-up" data-testid="landing-get-started-btn" className="rounded-[3px] bg-yellow-400 px-6 py-3 font-bold text-black hover:bg-yellow-300 transition-colors">Get started</Link>
          <Link to="/sign-in" data-testid="landing-sign-in-btn" className="rounded-[3px] border border-zinc-700 px-6 py-3 font-semibold hover:border-yellow-400 transition-colors">Sign in</Link>
        </div>
      </section>
    </div>
  );
}
